import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalCredentialPackageRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.CREDENTIAL_PACKAGES);
  }

  async getActiveByVesselId(vesselId) {
    return this.table
      .where("vesselId")
      .equals(vesselId)
      .filter((record) => record.isActive === true)
      .first();
  }

  async listByVesselId(vesselId) {
    return this.table.where("vesselId").equals(vesselId).sortBy("version");
  }

  async getLatestVersionByVesselId(vesselId) {
    const records = await this.listByVesselId(vesselId);
    return records.reduce(
      (highestVersion, record) => Math.max(highestVersion, record.version || 0),
      0
    );
  }
}
